export enum TipoSeguros {
RESIDENCIAL = "RESIDENCIAL",
    AUTO ="AUTO",
    MOTO ="MOTO",
    VIAGEM ="VIAGEM",
    VIDA ="VIDA",
    CAMINHAO = "CAMINHAO"
   }